/** Honorific prefixes that should not be used as an avatar initial (e.g. "د. أحمد" → "أ"). */
const honorifics = /^(?:د\.?|دكتور(?:ة)?|dr\.?|prof\.?|أ\.د\.?)\s+/i;

export function nameInitial(name: string | undefined | null): string {
  const cleaned = (name ?? "").trim().replace(honorifics, "").trim();
  return cleaned.slice(0, 1) || "؟";
}

/** Stable gradient class for an avatar, varied by id so adjacent rows differ. */
const avatarGradients = [
  "from-[#2156c4] to-[#4f8aed]",
  "from-[#4f6bc7] to-[#2156c4]",
  "from-[#1a7a5e] to-[#34d399]",
  "from-[#b07000] to-[#e0aa4a]",
  "from-[#6030b8] to-[#a880f0]",
  "from-[#0e7490] to-[#22d3ee]",
];

export function avatarGradient(seed: number): string {
  return avatarGradients[Math.abs(seed) % avatarGradients.length];
}
